import { render } from "./Legacy.vue?vue&type=template&id=0861f9b1"
import script from "./Legacy.vue?vue&type=script&lang=js"
export * from "./Legacy.vue?vue&type=script&lang=js"

import "./Legacy.vue?vue&type=style&index=0&id=0861f9b1&lang=scss"
script.render = render

export default script